import styled from 'styled-components';
import Ctr from '../Container/Container';

export const Wrapper = styled(Ctr)`
  display: flex;
  gap: 8px;
  z-index: 2;
  padding: 5px 0;
`;

export const BackButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.black};
  margin-left: -16px;
  padding: 8px 16px;
  border-radius: 4px;
  transition: transform 0.1s ease;

  &:hover {
    text-decoration: none;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    font-size: 16px;
  }

  a {
    text-decoration: none;
  }

  span {
    margin: 0;
    margin-top: 2px;
  }
`;

export const Label = styled.span`
  font-size: 14px;
  font-weight: 500;
`;
